export default {
  edit_note: 'Modifica nota',
  add_note: 'Aggiungi nota ',
  update: 'Aggiorna articolo',
  feedback: {
    item_sold_out_one: 'Ci dispiace, al momento {{items}} non è disponibile.',
    item_sold_out_other: 'Ci dispiace, al momento {{items}} non è disponibile.',
    item_unavailable:
      "Questo articolo è disponibile solo dalle {{schedule}}. Cambia l'orario dell'ordine o rimuovi l'articolo per ordinare.",
  },
  buttons: {
    update: 'Aggiorna',
  },
};
